import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../../misc/SmoothActionBar";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {useState} from "react";

export function HingeAutoDimensionOverride(props: {
    defaultValue: number;
    value: number | null;
    onClose(): void;
    onDone(qty: number | null): Promise<void>
}) {
    const onDoneRef = useSyncedRef(props.onDone);
    const onCloseRef = useSyncedRef(props.onClose);

    const action = useAsyncAction(async (input: {qty: number | null}) => {
        await onDoneRef.current(input.qty);
        onCloseRef.current();
    }, []);

    // separate hook so the Clear Override button has its own busy spinner
    const clearAction = useAsyncAction(async () => {
        await onDoneRef.current(null);
        onCloseRef.current();
    }, []);

    const [value, setValue] = useState(props.value === null ? "" : props.value.toString());
    const matchesDefault = parseInt(value || "0") === props.defaultValue;

    const submit = () => {
        const qty = value === "" || matchesDefault? null : parseInt(value);
        if(qty === props.value) {
            props.onClose();
            return;
        }

        action.callback({
            qty: qty,
        })
    };

    return (
        <Dialog2 open maxWidth="xs" fullWidth onClose={props.onClose} onEnterPress={submit}>
            <DialogTitle>Override Hinge Qty</DialogTitle>
            <DialogContent>
                <div style={{height: 6}} />
                <TextField label="Override Qty"
                           fullWidth variant="outlined"
                           value={value} onChange={e => setValue(e.target.value)}
                           helperText={matchesDefault ? "This will clear the override because it matches auto-calculated" : undefined}
                />
            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error || clearAction.error}
                actionName="Update"
                onSubmit={submit}
                onCancel={props.onClose}
                onDestroy={() => clearAction.callback(undefined)}
                destroyName="Clear Override"
                destroyLoading={clearAction.loading}
            />
        </Dialog2>
    )
}